export default "__VITE_ASSET__CFq2rs5R__"